import React, {
    Component
} from 'react';
import {
    handleCheckbox,
    handleRadio,
    countWords
} from '../helpers/Fields';
const $ = window.$;
export default class Inputgenerator extends Component {
    getValidationAttributes(qDetails) {
        let minLength = "",
            maxLength = "",
            minDate = "",
            maxDate = "",
            maxWords = 0,
            qConstraints = qDetails.constraints,
            inputClass = (qDetails.attribute.class !== undefined) ? qDetails.attribute.class : 'dynamic-question',
            style = (qDetails.attribute.style !== undefined) ? qDetails.attribute.style : {},
            rows = (qDetails.attribute.rows !== undefined) ? qDetails.attribute.rows : "",
            cols = (qDetails.attribute.cols !== undefined) ? qDetails.attribute.cols : "";
        if (qDetails.questionMandatory !== undefined && qDetails.questionMandatory) {
            inputClass += " required";
        }
        if (qConstraints !== undefined && qConstraints.charactersType !== undefined) {
            inputClass += (qConstraints.charactersType === 0) ? " digit" : "";
            inputClass += (qConstraints.charactersType === 1) ? " numeric" : "";
            inputClass += (qConstraints.charactersType === 2) ? " alpha" : "";
            inputClass += (qConstraints.charactersType === 3) ? " alphanumeric" : "";
        }
        if (qConstraints !== undefined && qConstraints.min !== undefined) {
            inputClass += " minlength";
            minLength = qConstraints.min;
        }
        if (qConstraints !== undefined && qConstraints.max !== undefined) {
            inputClass += " maxlength";
            maxLength = qConstraints.max;
        }
        if (qConstraints !== undefined && qConstraints.maxWords !== undefined) {
            inputClass += " word-count-check";
            maxWords = qConstraints.maxWords;
        }
        if (qConstraints !== undefined && qConstraints.minyear !== undefined) {
            minDate = qConstraints.minyear;
        }
        if (qConstraints !== undefined && qConstraints.maxyear !== undefined) {
            maxDate = qConstraints.maxyear;
        }
        return {
            "fieldName": qDetails.questionId,
            "value": qDetails.questionAnswer,
            "questionType": qDetails.questionType,
            "inputClass": inputClass,
            "style": style,
            "rows": rows,
            "cols": cols,
            "minLength": minLength,
            "maxLength": maxLength,
            "minDate": minDate,
            "maxDate": maxDate,
            "maxWords": maxWords
        }
    }
    render() {
        const {
            qDetails
        } = this.props;
        let qAttributes = this.getValidationAttributes(qDetails),
            scoreboard = "";
        return (<div className="custom-react-wrapper">
						{
								qDetails.questionType === "textbox" &&
                <div className="custom-react-wrapper">
								    <input className={qAttributes.inputClass} type="text" name={qAttributes.fieldName} id={qAttributes.fieldName} minLength={qAttributes.minLength} maxLength={qAttributes.maxLength} style={qAttributes.style} defaultValue={qAttributes.value} onKeyUp={(e)=>countWords(e)} data-total-words={qAttributes.maxWords} />
                    {
                        qAttributes.maxWords !== 0 &&
                        <div className="custom-react-wrapper">
                            <div className="max-words"><span className="date_red">Max words: {qAttributes.maxWords}</span></div>
                            <div className="word-count">
                                <span className="balance-words"></span>
                                <span className="typing-words"></span>
                            </div>
                        </div>
                    }
                </div>
						}
						{
								qDetails.questionType === "textarea" &&
                <div className="custom-react-wrapper">
    								<textarea className={qAttributes.inputClass} name={qAttributes.fieldName} id={qAttributes.fieldName} minLength={qAttributes.minLength} maxLength={qAttributes.maxLength} style={qAttributes.style} cols={qAttributes.cols} rows={qAttributes.rows} defaultValue={qAttributes.value} onKeyUp={(e)=>countWords(e)} data-total-words={qAttributes.maxWords}></textarea>
                    {
                        qAttributes.maxWords !== 0 &&
                        <div className="custom-react-wrapper">
                            <div className="max-words"><span className="date_red">Max words: {qAttributes.maxWords}</span></div>
                            <div className="word-count">
                                <span className="balance-words"></span>
                                <span className="typing-words"></span>
                            </div>
                        </div>
                    }
                </div>
						}
						{
								qDetails.questionType === "radio" &&
								<ul className="list-items">
										{
												qDetails.questionChoice.map((choicedetails)=>{
														if (choicedetails.choice !== "") {
																if (qDetails.questionAnswer === "" && choicedetails.score !== undefined){
																		(choicedetails.score === 0)? scoreboard = <img src={process.env.PUBLIC_URL+"/images/crossmark.gif"} width='11' height='11' alt='' border='0' style={{display:'none'}}/> : scoreboard = <img src={process.env.PUBLIC_URL+"/images/tick.gif"} width='15' height='14' alt='' border='0' style={{display:'none'}}/>;
																}
																else {
																		(choicedetails.id === qDetails.questionAnswer)?(choicedetails.score === 0)? scoreboard = <img src={process.env.PUBLIC_URL+"/images/crossmark.gif"} width='11' height='11' alt='' border='0' style={{display:'inline-block'}}/> : scoreboard = <img src={process.env.PUBLIC_URL+"/images/tick.gif"} width='15' height='14' alt='' border='0' style={{display:'inline-block'}}/> : (choicedetails.score === 0)? scoreboard = <img src={process.env.PUBLIC_URL+"/images/crossmark.gif"} width='11' height='11' alt='' border='0' style={{display:'none'}}/> : scoreboard = <img src={process.env.PUBLIC_URL+"/images/tick.gif"} width='15' height='14' alt='' border='0' style={{display:'none'}}/>;
																}

																return <span key={`list_${qAttributes.fieldName}_${choicedetails.id}`}>
																		<li>
																				<input name={qAttributes.fieldName} type="radio" value={choicedetails.id} onClick={(e)=>handleRadio(e)} defaultChecked={$.inArray(choicedetails.id, qAttributes.value)>=0} style={qAttributes.style} /> {choicedetails.choice}
																				&nbsp;&nbsp;{scoreboard}
																		</li>
																</span>
														}
												})
										}
										<li>
												<input className={qAttributes.inputClass} type="hidden" name={qAttributes.fieldName+"_hidden"} defaultValue={qAttributes.value.toString()} />
										</li>
								</ul>
						}
						{
								qDetails.questionType === "checkbox" &&
								<ul className="list-items">
										{
												qDetails.questionChoice.map((choicedetails)=>{
														return <li key={`list_${qAttributes.fieldName}_${choicedetails.id}`}>
																<input name={qAttributes.fieldName} type="checkbox" value={choicedetails.id} onChange={(e)=>handleCheckbox(e)} defaultChecked={$.inArray(choicedetails.id, qAttributes.value)>=0} style={qAttributes.style} /> {choicedetails.choice}
														</li>
												})
										}
										<li>
												<input className={qAttributes.inputClass} type="hidden" name={qAttributes.fieldName+"_hidden"} defaultValue={qAttributes.value.toString()} />
										</li>
								</ul>
						}
						{
								qDetails.questionType === "combo" &&
								<select className={qAttributes.inputClass} name={qAttributes.fieldName} id={qAttributes.fieldName} defaultValue={qAttributes.value.toString()} style={qAttributes.style}>
										<option value="">Select</option>
										{
												qDetails.questionChoice.map((choicedetails)=> {
														return <option key={`option_${qAttributes.fieldName}_${choicedetails.id}`} value={choicedetails.id}>{choicedetails.choice}</option>
												})
										}
								</select>
						}
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/Inputgenerator.js